




























































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { readEntryByLabel, readSectionsString } from "@/store/uniabc/getters";
import Entry from "@/interfaces/uniabc/Entry";
import { dispatchUpdateEntry } from "@/store/uniabc/actions";
import LocalReferenceList from "@/components/editor/references/LocalReferenceList.vue";
import SetImage from "@/components/editor/editing/SetImage.vue";
import GlobalReferenceList from "@/components/editor/references/GlobalReferenceList.vue";
import EditorTooltip from "@/components/editor/editing/EditorTooltip.vue";

@Component({
  components: {
    EditorTooltip,
    SetImage,
    LocalReferenceList,
    GlobalReferenceList
  }
})
export default class EntryEditor extends Vue {
  @Prop(String) readonly label!: string;
  @PropSync("recomputeRefs", { type: Number }) updateRefs!: number;
  private entry!: Entry;

  private availableSections = readSectionsString(this.$store)();

  // $refs: {
  //   taDE: typeof VTextarea,
  //   taEN: typeof VTextarea
  // }

  public async created() {
    this.entry = readEntryByLabel(this.$store)(this.label || "");
  }

  private onEntryChanged() {
    dispatchUpdateEntry(this.$store, this.entry);
  }

  // https://stackoverflow.com/a/49852481
  private addCharAtCursor(char: string, lang: string, skip: number) {
    const textarea = (this.$refs[lang === "de" ? "taDE" : "taEN"] as any).$refs
      .input;

    const sentence = textarea.value;
    const len = sentence.length;
    let pos = textarea.selectionStart;
    if (pos === undefined) {
      pos = 0;
    }

    const before = sentence.substr(0, pos);
    const after = sentence.substr(pos, len);

    this.entry[lang === "de" ? "text_de" : "text_en"] = before + char + after;

    this.$nextTick().then(() => {
      textarea.focus();
      textarea.selectionStart = pos + (skip || char.length);
      textarea.selectionEnd = pos + (skip || char.length);
    });
  }
}
